
@if (data.accessGranted) {
  <header></header>
}
<mat-sidenav-container>
  <mat-sidenav mode="push" position="end" [opened]="data.sidenavOpened | async">
    <ul class="links">
      @for (link of reports|async; track link) {
        <li [routerLink]="link.link" (click)="close()" routerLinkActive="active">{{ 'menu.'+link.text | translate }}</li>
      }
      <li (click)="close()" routerLink="/about" routerLinkActive="active">{{ 'menu.about' | translate }}</li>
      <li (click)="close()" routerLink="/help" routerLinkActive="active">{{ 'menu.help' | translate }}</li>
    </ul>
    <app-theme-switcher></app-theme-switcher>
  </mat-sidenav>
  <mat-sidenav-content class="content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<div (swipeleft)="data.sidenavOpened.next(true)" class="menu-swipper"></div>
<footer></footer>

<loader></loader>